<!--
 * @Author:
 * @LastEditTime: 2022-04-18 16:28:29
 * @Description: 出入场历史记录
-->
<template>
  <el-dialog
    v-dialogDrag
    class="mid-dialog"
    :append-to-body="true"
    :visible.sync="visible"
    title="单位出入场历史记录"
  >
    <el-table v-loading="historyLoading" :data="historyList" border stripe :height="tableHeight">
      <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
      <el-table-column
        label="单位名称"
        prop="orgName"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="所属项目"
        prop="projectNames"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column label="单位负责人" prop="orgLeader" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="联系电话" prop="phoneNumber" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="申报时间" prop="declarationTime" align="center" width="180">
        <template slot-scope="scope">
          {{
            scope.row.declarationTime &&
              dayjs(scope.row.declarationTime).format('YYYY-MM-DD HH:mm:ss')
          }}
        </template>
      </el-table-column>
      <el-table-column label="退厂时间" prop="exitTime" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.exitTime && dayjs(scope.row.exitTime).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
    </el-table>
    <div class="flex justify-end mt-10px">
      <el-pagination
        background
        @size-change="tableHistorySizeChange"
        @current-change="tableHistoryCurrentChange"
        :current-page.sync="pageHistoryConfig.SkipCount"
        :page-size.sync="pageHistoryConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="historyTotalCount"
        class="float-right mt-10px ml-10px"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs'
import { ContractorEntryExitRecordsApi } from '@wiz-api/contractor-management'

const contractorEntryExitRecordsApi = new ContractorEntryExitRecordsApi()

export default {
  name: 'enter-and-leave-records',
  props: {
    contractId: {
      type: String,
      default: '',
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
  },
  data() {
    return {
      visible: true,
      historyLoading: false,
      historyList: [],
      pageHistoryConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      historyTotalCount: 0,
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 60px)'
    },
  },
  created() {
    this.getHistoryList()
  },
  methods: {
    // 页码改变
    tableHistorySizeChange(MaxResultCount) {
      this.pageHistoryConfig.MaxResultCount = MaxResultCount
      this.getHistoryList()
    },
    // 页数改变
    tableHistoryCurrentChange(SkipCount) {
      this.pageHistoryConfig.SkipCount = SkipCount
      this.getHistoryList()
    },
    // 获取出入场历史记录
    async getHistoryList() {
      this.historyLoading = true
      const data = {
        maxResultCount: this.pageHistoryConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageHistoryConfig.SkipCount - 1) * this.pageHistoryConfig.MaxResultCount, // 跳过多少条
        contractorId: this.contractId,
      }
      const [err, res] = await contractorEntryExitRecordsApi.pagedListQuery(data)
      if (!err) {
        this.historyList = res.items
        this.historyTotalCount = res.totalCount
      }
      this.historyLoading = false
    },
    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<style></style>
